export default __webpack_public_path__ + "428c0ec7e1977e30b4009e9c02b171a1.svg";